import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const ModelListItem = ({
  label,
  onClick,
  isFavorite = false,
  onToggleFavorite,
  favoriteDisabled = false,
}) => {
  const showFavorite = typeof onToggleFavorite === 'function';

  return (
    <div
      className={cn(
        'w-full flex items-center gap-1',
        'rounded-lg border border-transparent bg-muted/30',
        'hover:bg-primary/12 hover:border-primary/30',
        'transition-smooth group'
      )}
    >
      {showFavorite ? (
        <button
          type="button"
          disabled={favoriteDisabled}
          aria-label={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
          aria-pressed={isFavorite}
          onClick={(event) => {
            event.stopPropagation();
            onToggleFavorite();
          }}
          className={cn(
            'shrink-0 p-2 rounded-lg transition-smooth',
            'hover:bg-primary/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            favoriteDisabled && 'opacity-50 pointer-events-none'
          )}
        >
          <Icon
            name="Star"
            size={16}
            className={cn(
              isFavorite
                ? 'text-amber-500 fill-amber-500'
                : 'text-muted-foreground group-hover:text-primary'
            )}
            fill={isFavorite ? 'currentColor' : 'none'}
          />
        </button>
      ) : null}

      <button
        type="button"
        onClick={onClick}
        className="flex-1 min-w-0 flex items-center justify-between gap-2 px-2 py-2 text-left rounded-lg"
      >
        <span className="text-sm text-foreground truncate group-hover:text-primary">
          {label}
        </span>
        <Icon
          name="ChevronRight"
          size={16}
          className="text-muted-foreground group-hover:text-primary shrink-0"
        />
      </button>
    </div>
  );
};

export default ModelListItem;
